import tinymce from 'tinymce'
import plugin from './plugin'

tinymce.PluginManager.add('tistory-plugins', plugin)
